(function () {
  const MODAL_ID = "branded-sticker";
  const SUMMARY_ROOT_ID = "framefox-branded-sticker-selector";
  const MODAL_ROOT_ID = "framefox-branded-sticker-modal-root";
  const MODAL_OPTIONS_ID = "framefox-branded-sticker-modal-options";
  const MODAL_LOADING_ID = "framefox-branded-sticker-modal-loading";
  const MODAL_EMPTY_ID = "framefox-branded-sticker-modal-empty";
  const MODAL_SAVE_ID = "framefox-branded-sticker-save";
  const MODAL_ACTIONS_ID = "framefox-branded-sticker-modal-actions";
  const RADIO_NAME = "framefox-branded-sticker-option";

  const state = {
    options: [],
    defaultGiftOptionId: "",
    pendingGiftOptionId: "",
    loadingPromise: null,
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  async function parseJsonResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return {};
    }
  }

  function getSummaryRoot() {
    return document.getElementById(SUMMARY_ROOT_ID);
  }

  function getModalRoot() {
    return document.getElementById(MODAL_ROOT_ID);
  }

  function getManageUrl() {
    return getSummaryRoot()?.dataset.manageUrl || getModalRoot()?.dataset.manageUrl || "/apps/frame/pro/branded-stickers";
  }

  function getOptionsUrl() {
    return getSummaryRoot()?.dataset.optionsUrl || getModalRoot()?.dataset.optionsUrl;
  }

  function getSelectedGiftOptionId() {
    return getSummaryRoot()?.dataset.selectedGiftOptionId || "";
  }

  function dispatchModalState(open) {
    window.dispatchEvent(
      new CustomEvent("set-open", {
        detail: {
          id: MODAL_ID,
          open,
        },
      }),
    );
  }

  function setSaveButtonState({ disabled, label }) {
    const saveButton = document.getElementById(MODAL_SAVE_ID);
    if (!saveButton) {
      return;
    }

    saveButton.disabled = disabled;
    saveButton.textContent = label;
  }

  function resolveCurrentGiftOption() {
    const selectedGiftOptionId = getSelectedGiftOptionId();

    return (
      state.options.find((option) => String(option.id) === selectedGiftOptionId) ||
      state.options.find((option) => String(option.id) === state.defaultGiftOptionId) ||
      null
    );
  }

  const FALLBACK_THUMB_HTML =
    '<i class="fa-light fa-address-card text-2xl text-stone-400"></i>';

  function renderSummary() {
    const summaryRoot = getSummaryRoot();
    if (!summaryRoot) {
      return;
    }

    const thumb = document.getElementById("framefox-branded-sticker-thumb");
    const title = document.getElementById("framefox-branded-sticker-title");
    const manageLink = document.getElementById("framefox-branded-sticker-manage-inline");
    const openButton = summaryRoot.querySelector("[data-branded-sticker-open]");

    if (!thumb || !title || !manageLink || !openButton) {
      return;
    }

    if (state.options.length === 0) {
      thumb.innerHTML = FALLBACK_THUMB_HTML;
      title.textContent = "No branded stickers available";
      manageLink.classList.remove("hidden");
      openButton.disabled = true;
      return;
    }

    const currentGiftOption = resolveCurrentGiftOption();
    if (!currentGiftOption) {
      thumb.innerHTML = FALLBACK_THUMB_HTML;
      title.textContent = "Branded sticker unavailable";
      manageLink.classList.remove("hidden");
      openButton.disabled = true;
      return;
    }

    thumb.innerHTML = currentGiftOption.image_url
      ? `<img src="${escapeHtml(currentGiftOption.image_url)}" alt="${escapeHtml(currentGiftOption.title)}" class="block h-full w-auto max-w-full object-contain" loading="lazy">`
      : FALLBACK_THUMB_HTML;
    title.textContent = currentGiftOption.title || "Untitled sticker";
    manageLink.classList.add("hidden");
    openButton.disabled = false;
  }

  function renderModal() {
    const optionsContainer = document.getElementById(MODAL_OPTIONS_ID);
    const loadingContainer = document.getElementById(MODAL_LOADING_ID);
    const emptyContainer = document.getElementById(MODAL_EMPTY_ID);
    const actionsContainer = document.getElementById(MODAL_ACTIONS_ID);

    if (!optionsContainer || !loadingContainer || !emptyContainer) {
      return;
    }

    if (state.options.length === 0) {
      loadingContainer.classList.add("hidden");
      optionsContainer.classList.add("hidden");
      emptyContainer.classList.remove("hidden");
      actionsContainer?.classList.add("hidden");
      setSaveButtonState({ disabled: true, label: "Save sticker" });
      return;
    }

    const selectedId = state.pendingGiftOptionId || String(resolveCurrentGiftOption()?.id || "");

    loadingContainer.classList.add("hidden");
    emptyContainer.classList.add("hidden");
    optionsContainer.classList.remove("hidden");
    actionsContainer?.classList.remove("hidden");
    optionsContainer.innerHTML = state.options
      .map((option) => {
        const optionId = String(option.id);
        const selected = optionId === selectedId;
        const checked = selected ? "checked" : "";
        const selectedClasses = selected
          ? "border-stone-900 bg-stone-50 ring-1 ring-stone-900"
          : "border-stone-200 bg-white";

        return `
          <label class="flex h-full cursor-pointer flex-col rounded-xl border p-4 text-center transition-colors hover:border-stone-400 ${selectedClasses}">
            <input type="radio" name="${RADIO_NAME}" value="${escapeHtml(optionId)}" class="sr-only" ${checked}>
            <div class="relative mb-4">
              <div class="mx-auto flex aspect-[4/3] w-full max-w-[220px] items-center justify-center overflow-hidden rounded-lg bg-stone-100 p-2">
                ${
                  option.image_url
                    ? `<img src="${escapeHtml(option.image_url)}" alt="${escapeHtml(option.title)}" class="block h-full w-auto max-w-full object-contain" loading="lazy">`
                    : '<i class="fa-light fa-address-card text-3xl font-normal text-stone-500"></i>'
                }
              </div>
              <div class="absolute right-0 top-0 flex h-5 w-5 items-center justify-center rounded-full border ${selected ? "border-stone-900 bg-stone-900 text-white" : "border-stone-300 bg-white"}">
                <i class="fa-solid fa-check text-[10px] ${selected ? "" : "opacity-0"}"></i>
              </div>
            </div>
            <div class="flex min-h-[52px] flex-col items-center justify-start gap-2">
              <p class="mb-0 font-medium text-stone-900">${escapeHtml(option.title || "Untitled sticker")}</p>
              ${
                option.is_default_order_sticker
                  ? '<span class="inline-flex items-center rounded-full bg-stone-900 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-white">Default</span>'
                  : ""
              }
            </div>
          </label>
        `;
      })
      .join("");

    setSaveButtonState({ disabled: !selectedId, label: "Save sticker" });
  }

  async function loadOptions() {
    const optionsUrl = getOptionsUrl();
    if (!optionsUrl) {
      state.options = [];
      state.defaultGiftOptionId = "";
      renderSummary();
      renderModal();
      return state;
    }

    if (!state.loadingPromise) {
      state.loadingPromise = fetch(optionsUrl, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then(async (response) => {
          const payload = await parseJsonResponse(response);

          state.options = Array.isArray(payload.gift_options) ? payload.gift_options : [];
          state.defaultGiftOptionId = payload.default_gift_option_id ? String(payload.default_gift_option_id) : "";

          return state;
        })
        .catch((error) => {
          console.error("Failed to load branded sticker options:", error);
          state.options = [];
          state.defaultGiftOptionId = "";
          return state;
        });
    }

    await state.loadingPromise;
    renderSummary();
    renderModal();
    return state;
  }

  async function openBrandedStickerModal() {
    const loadingContainer = document.getElementById(MODAL_LOADING_ID);
    const optionsContainer = document.getElementById(MODAL_OPTIONS_ID);
    const emptyContainer = document.getElementById(MODAL_EMPTY_ID);

    if (loadingContainer && optionsContainer && emptyContainer) {
      loadingContainer.classList.remove("hidden");
      optionsContainer.classList.add("hidden");
      emptyContainer.classList.add("hidden");
    }

    await loadOptions();
    state.pendingGiftOptionId = String(resolveCurrentGiftOption()?.id || state.defaultGiftOptionId || "");
    renderModal();
    dispatchModalState(true);
  }

  async function saveSelection() {
    const selectedGiftOptionId =
      state.pendingGiftOptionId ||
      document.querySelector(`input[name="${RADIO_NAME}"]:checked`)?.value ||
      "";

    if (!selectedGiftOptionId) {
      return;
    }

    setSaveButtonState({ disabled: true, label: "Saving..." });

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          attributes: {
            _GiftOptionID: selectedGiftOptionId,
          },
        }),
      });

      const payload = await parseJsonResponse(response);

      if (!response.ok) {
        throw new Error(payload.description || payload.error || "Could not update the branded sticker");
      }

      const summaryRoot = getSummaryRoot();
      if (summaryRoot) {
        summaryRoot.dataset.selectedGiftOptionId = selectedGiftOptionId;
      }

      if (typeof update_cart === "function") {
        await update_cart("#cart-form");
      } else {
        window.location.reload();
        return;
      }

      dispatchModalState(false);
      setSaveButtonState({ disabled: false, label: "Save sticker" });
    } catch (error) {
      console.error("Failed to save branded sticker selection:", error);
      alert(error.message || "Could not update the branded sticker right now. Please try again.");
      setSaveButtonState({ disabled: false, label: "Save sticker" });
    }
  }

  function initBrandedStickerSelector() {
    const summaryRoot = getSummaryRoot();
    if (!summaryRoot) {
      return;
    }

    loadOptions();
  }

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest("[data-branded-sticker-open]");
    if (openButton) {
      event.preventDefault();
      openBrandedStickerModal();
      return;
    }

    const saveButton = event.target.closest(`#${MODAL_SAVE_ID}`);
    if (saveButton) {
      event.preventDefault();
      saveSelection();
    }
  });

  document.addEventListener("change", (event) => {
    const radioInput = event.target.closest(`input[name="${RADIO_NAME}"]`);
    if (!radioInput) {
      return;
    }

    state.pendingGiftOptionId = radioInput.value;
    renderModal();
  });

  document.addEventListener("DOMContentLoaded", initBrandedStickerSelector);
  document.addEventListener("framefox:cart-updated", initBrandedStickerSelector);

  if (document.readyState !== "loading") {
    initBrandedStickerSelector();
  }
})();
